import { useState, useCallback } from "react";
import styles from "./RepositionWidth.module.css";
import { MdAdd } from "react-icons/md"
import { FiMinus} from "react-icons/fi"

const RepositionWidth = (props) => {
  const { setRepositionWidth } = props;

  const [percentageValue, setPercentageValue] = useState(null);
  //eslint-disable-next-line
  const [ambientWidth, setAmbientWidth] = useState(false);
  function handleAmbientUpdate() {
    updateWithOptionButtons(100);
    setAmbientWidth(true);
  }

  function transformValue(input) {
    const numInput = parseFloat(input);
    const scaledInput = numInput / (100 - numInput);
    const output = (scaledInput * 100).toFixed(2);
    return output;
  }

  const handleRespositionSlider = useCallback((event) => {
    const { value } = event.target;

    const humanReadableValue = transformValue(value);
    setPercentageValue(humanReadableValue);
    setRepositionWidth(humanReadableValue);
    if (humanReadableValue === "Infinity") {
      setAmbientWidth(true);
    } else if (value !== 100) {
      setAmbientWidth(false);
    }
    //eslint-disable-next-line
  }, []);

  const updateWithOptionButtons = useCallback(
    (value) => {
      document.getElementById("input-slider-reposition").value = value;
      const humanReadableValue = transformValue(value);

      setRepositionWidth(humanReadableValue);
      setPercentageValue(humanReadableValue);
    },
    [setRepositionWidth]
  );
    
    const PercentageOptionContent = (
        <>
            <div className={styles.percentage_options}>

                <div className={styles.add_minus_icons}>
                    <MdAdd size={22}  />
                    <FiMinus size={22}  />
                 
                </div>
            <button
              className={styles.percentage_option_buttons}
              onClick={() => {
                updateWithOptionButtons((1 / 3) * 100);
                setAmbientWidth(false);
              }}
            >
              50%
            </button>
            <button
              className={styles.percentage_option_buttons}
              onClick={() => {
                updateWithOptionButtons((1 / 2) * 100);
                setAmbientWidth(false);
              }}
            >
              100%
            </button>
            <button
              className={styles.percentage_option_buttons}
              onClick={() => {
                updateWithOptionButtons((2 / 3) * 100);
                setAmbientWidth(false);
              }}
            >
              200%
            </button>
            {/* <button
              className={styles.percentage_option_buttons}
              onClick={() => {
                updateWithOptionButtons((48 / 60) * 100);
                setAmbientWidth(false);
              }}
            >
              400%
            </button> */}
            <button
              className={styles.percentage_option_buttons}
              onClick={() => handleAmbientUpdate()}
            >
              Ambient
            </button>
          </div>
        </>
    )

  return (
    <div className={styles.reposition_width_container}>
      <div className={styles.reposition_width_content}>
              <span className={styles.reposition_width_title}>
                  Reposition Width
               
              </span>
              {PercentageOptionContent}
              <span className={styles.percentage_amount} id="percentage-output">
            {ambientWidth ? "Ambient" : `${percentageValue || "150.00"}%`}{" "}
          </span>
        <div className={styles.reposition_width_input}>
          <span>25%</span>
          <input
            size="28"
            aria-labelledby="input slider"
            id="input-slider-reposition"
            min="20"
            max="100"
            step="1"
            defaultValue={60}
            type="range"
            className={styles.percentage_input}
            onChange={handleRespositionSlider}
          />
          <span style={{ fontSize: "2rem" }}>∞</span>
        </div>

        <div className={styles.percentage_container}>
       
        </div>
      </div>
    </div>
  );
};

export default RepositionWidth;
